import React from 'react';
import { Alert as AntAlert, type AlertProps } from 'antd';
import { useTheme } from '@emotion/react';
import CommonAlert, { type Env0AlertProps } from 'components/common/feedback/alert';

// The seam between antd's prop surface and the wrapper's — the one call site to adapt if they diverge.
// Only an incompatible divergence errors here; a prop dropped from the Pick still flows at runtime.
export const toCommonProps = (props: AlertProps): Env0AlertProps => props;

/**
 * For the 67 call sites importing Alert straight from antd. Legacy renders antd's Alert verbatim, so
 * switch-off parity is true by construction; the new design routes through the wrapper. APO-484 removes
 * the branch and leaves every site on the wrapper - this is the grep for that sweep.
 *
 * No `Object.assign` static, unlike BridgedButton's `__ANT_BUTTON`: Alert has no compat flag read off
 * the child's type, and nothing uses `Alert.ErrorBoundary`.
 */
export const BridgedAlert: React.FC<AlertProps> = props => {
  const theme = useTheme();

  return theme.isNewDesign ? <CommonAlert {...toCommonProps(props)} /> : <AntAlert {...props} />;
};

export default BridgedAlert;
